import type { ReactNode } from 'react';
import { useEffect } from 'react';

interface Props {
  open: boolean;
  onClose: () => void;
  title?: string;
  lede?: string;
  children: ReactNode;
  footer?: ReactNode;
  /** sm = 460, md = 520 (default), lg = 640. */
  size?: 'sm' | 'md' | 'lg';
}

export function Modal({ open, onClose, title, lede, children, footer, size = 'md' }: Props) {
  useEffect(() => {
    if (!open) return;
    function onKey(e: KeyboardEvent) { if (e.key === 'Escape') onClose(); }
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="modal-back" role="dialog" aria-modal="true" onClick={onClose}>
      <div className={`modal-card modal-${size}`} onClick={(e) => e.stopPropagation()}>
        {title && <h3>{title}</h3>}
        {lede && <p className="lead">{lede}</p>}
        {children}
        {footer && <div className="modal-actions">{footer}</div>}
      </div>
    </div>
  );
}
